/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showRegistration } from '../../../store/actions/modalWindowsActions';
import Main from '../Main/Main';
import Services from '../Services/Services';
import Activities from '../Activities/Activities';
import Community from '../Community/Community';
import Management from '../Management/Management';
import NewsEvents from '../NewsEvents/NewsEvents';
import OurPartners from '../OurPartners/OurPartners';
import Forms from '../Forms/Forms';
import Registration from '../../ModalWindows/Registration/Registration';
import InfoMessage from '../../ModalWindows/InfoMessage/InfoMessage';
import './Landing.scss';

export default function Landing() {
  const { t } = useTranslation('info_messages');
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const eventsNotification = useSelector((state) => state.events.notification);
  const managersNotification = useSelector((state) => state.managers.notification);
  const articlesNotification = useSelector((state) => state.articles.notification);
  const vipCompaniesNotification = useSelector((state) => state.vipCompanies.notification);
  const { isRegistrationVisible } = useSelector((state) => state.modalWindows.registration);
  const {
    isInfoMessageVisible,
    contentKey,
  } = useSelector((state) => state.modalWindows.infoMessage);

  useEffect(() => {
    if (location.search) {
      const resetPasswordToken = searchParams.get('reset_password_token');
      const email = searchParams.get('email');

      if (resetPasswordToken && email) {
        dispatch(showRegistration(resetPasswordToken, email));
      }
    }

    if (location.hash) {
      let css;

      switch (location.hash) {
        case '#main':
          css = '.Main';
          break;
        case '#services':
          css = '.Services';
          break;
        case '#activities':
          css = '.Activities';
          break;
        case '#about-us':
          css = '.Management';
          break;
        case '#news-events':
          css = '.NewsEvents';
          break;
        case '#forms':
          css = '.Forms';
          break;
        default:
          break;
      }

      const section = document.querySelector(css);

      window.scrollTo({
        left: 0,
        top: section.offsetTop,
        behavior: 'instant',
      });
    }
  }, [eventsNotification, managersNotification, articlesNotification, vipCompaniesNotification]);

  return (
    <>
      <Main />
      <NewsEvents />
      <Services />
      <Activities />
      <Management />
      <Community />
      <OurPartners />
      <Forms />
      {
        isRegistrationVisible && <Registration />
      }
      {
        isInfoMessageVisible && contentKey === 'successful_registration' && (
        <InfoMessage>
          {t('successful_registration')}
        </InfoMessage>
        )
      }
    </>
  );
}
